import { COUNTRY_DOCUMENT_TYPE_DNI } from 'constants/multiLanguage';

export const validateSecondLastName = ({ name, lastName, secondLastName, documentType }) => {
    if (documentType === COUNTRY_DOCUMENT_TYPE_DNI && !secondLastName) {
        return !(name && lastName);
    }

    return true;
};
